export interface LevelBadgeProps {
  level: number;
  size?: "sm" | "md";
}

export function LevelBadge({ level, size = "md" }: LevelBadgeProps) {
  return (
    <div className={`jaiho-level-badge jaiho-level-badge--${size}`}>
      <span className="jaiho-level-badge__num">{level}</span>
    </div>
  );
}
